<mapfre-modal
  [modalOptions]="uploadingFiles"
  [hideModal]="hideModalOnRoute"
  (closeModal)="resetHideModal($event)"
>
  <div class="modal-body no-margin-top margin-bottom mb8">
    <ng-container *ngIf="isAcmic; else maHeader">
      <hr class="margin-bottom mb16 no-margin-top"/>                              
    </ng-container>
    <ng-template #maHeader>
      <div class="ma-modal-title">{{'Edit file' | translate}}</div>                                                                
    </ng-template>

    <div class="uploading-files margin-top mt24 text-center">
      <div class="inner-block ml-auto mr-auto">
        <div>
          <img src="./assets/img/images/icon-uploading-files.svg" alt="uploading files icon" />
        </div>
        <div class="document-message margin-top mt16">
          {{ uploadedFile }}
        </div>
        <div class="select-type-doc margin-top mt24">
          <label for="select-topic" class="select-label">
            {{ "Type *" }}
          </label>
          <select class="form-control selection-input-color mb8" name="select-topic"
          [(ngModel)]="documentType">
            <option disabled>{{ documentType }}</option>
            <option>Scene Photos</option>
            <option>Vehicle Photos</option>
            <option>Incident Reports</option>
            <option>Receipts/Invoices</option>
            <option>Other</option>
          </select>
        </div>
      </div>
    </div>
    <hr class="ma-hr-tag" *ngIf="!isAcmic">
    <div class="show-btn-order text-right margin-bottom mb16 margin-top mt24">
      <mapfre-button
        (click)="onCancel()"
        additionalClasses="ghost secondary small-btn modal-small-btn letter-space-17 {{isAcmic ?  'no-padding' : ''}}"
        >{{ "Discard changes" | translate }}
      </mapfre-button>
      <mapfre-button
        (click)="onSave()"
        additionalClasses="basic primary small-btn margin-bottom modal-small-btn letter-space-17"   
        [inputType]="'submit'"
        [disabledValue]="documentType?.length"
        [translateValue]="'Save' | translate"     
      >
        {{ "Save" | translate }}
      </mapfre-button>
    </div>
  </div>
</mapfre-modal>
